export enum AuthOptions {
	APP ='app',
	BACKUP ='backup',
	SMS ='sms'
}
